// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38fyB","col":"styles_col__mqGlF"};